import { useEffect, useState } from 'react';
import ApiDatabase from 'server';
import {
  REFERENTIAL_STATUS,
  sortRiskyPositions,
  toOptionNames,
} from './qualificationRequirements';

const loading = () => ({ items: [], status: REFERENTIAL_STATUS.LOADING });

/**
 * The three lists the risk and requirements tabs choose from, read once when
 * the panel opens. Each one fails on its own: the rest of the form stays usable.
 */
const useQualificationReferentials = () => {
  const [riskyPositions, setRiskyPositions] = useState(loading);
  const [toolOptions, setToolOptions] = useState(loading);
  const [licenceOptions, setLicenceOptions] = useState(loading);

  useEffect(() => {
    let isMounted = true;
    const token = localStorage.getItem('xsrfToken');
    const ready = (setList, toItems) => (data) => {
      if (isMounted) {
        setList({ items: toItems(data), status: REFERENTIAL_STATUS.READY });
      }
    };
    const failed = (setList) => (err) => {
      if (err?.name === 'CanceledError') return;
      console.error(err);
      if (isMounted) setList({ items: [], status: REFERENTIAL_STATUS.FAILED });
    };

    ApiDatabase.getRiskyPositions(
      { token },
      ready(setRiskyPositions, sortRiskyPositions),
      failed(setRiskyPositions),
    );
    ApiDatabase.getListTools(
      ready(setToolOptions, toOptionNames),
      failed(setToolOptions),
    );
    ApiDatabase.getAllLicence(
      ready(setLicenceOptions, toOptionNames),
      failed(setLicenceOptions),
    );

    return () => {
      isMounted = false;
    };
  }, []);

  return { riskyPositions, toolOptions, licenceOptions };
};

export default useQualificationReferentials;
